<template>
	<div>
		<buttonlist
				@help="help"
				@opentable="opentable"
				@search="search"
				@reflash="reflash"
				@exps="exp"
				@imp="impt"
				@del="del"
				ref="SetBtn"
		></buttonlist>
		<el-tabs @tab-click="tabclick" v-model="SelectIndexs">
			<el-tab-pane :label="$t('getapi[7936]')" name="0" id="xpane-0">
				<div>
					<el-button type="primary" size="mini" @click="monthCheck(0)" :disabled="!btn.monthcheck">{{$t('getapi[1273]')}}</el-button>
				</div>
				<wTable
						:data="dataSet"
						:loading="loading"
						queryData="SalTruInfoView"
						:filter_thousandth="['DN_Quantity','Local_Net_Unit','Local_Net_Amount','Base_Net_Unit','Base_Net_Amount','Issue_Material_Unit',
				'Issue_Man_Unit','Issue_Charge_Unit','Issue_Material_Amount']"
						:filter_date="['Invoice_Create_Date','Invoice_Audit_Date','Finance_Date']"
						:header="tableHeader"
						:option="tableOption"
						ref="singleTable"
						:checkflg="false"
				></wTable>
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[9903]')" name="1" id="xpane-1">
				<wTable
						:data="dataSet1"
						:loading="loading"
						queryData="SalTruInfoView"
						:filter_thousandth="['DN_Quantity','Local_Net_Unit','Local_Net_Amount','Base_Net_Unit','Base_Net_Amount','Issue_Material_Unit',
				'Issue_Man_Unit','Issue_Charge_Unit','Issue_Material_Amount']"
						:filter_date="['Invoice_Create_Date','Invoice_Audit_Date','Finance_Date']"
						:header="tableHeader"
						:option="tableOption1"
						@handleSelectionChange="handleSelectionChange1"
						ref="singleTable1"
				></wTable>
			</el-tab-pane>
		</el-tabs>

		<!--<el-table
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight  - reduceTableHeight"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="DN_Year" :label="$t('getapi[7937]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="DN_Month" :label="$t('getapi[7938]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Order_No" :label="$t('getapi[2292]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Finance_Date" :label="$t('getapi[6489]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_first_name" :label="$t('getapi[169]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_second_name" :label="$t('getapi[170]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_third_name" :label="$t('getapi[171]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="item_code" :label="$t('getapi[3437]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Create_Date" :label="$t('getapi[7742]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Audit_Date" :label="$t('getapi[3892]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="DN_Quantity" :label="$t('getapi[7939]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Local_Net_Unit" :label="$t('getapi[3843]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Local_Net_Amount" :label="$t('getapi[3844]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Base_Net_Unit" :label="$t('getapi[7940]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Base_Net_Amount" :label="$t('getapi[7941]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Customer_Name" :label="$t('getapi[2584]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Material_Unit" :label="$t('getapi[7750]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Man_Unit" :label="$t('getapi[7751]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Charge_Unit" :label="$t('getapi[7752]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Material_Amount" :label="$t('getapi[7585]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Man_Amount" :label="$t('getapi[7586]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Charge_Amount" :label="$t('getapi[7587]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="order_n" :label="$t('getapi[2291]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Currency_Code" :label="$t('getapi[3108]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Delivery_Note_N" :label="$t('getapi[7942]')"></el-table-column>
		</el-table>-->
		<el-row v-if="SelectIndexs == 0" class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
					}}
				</div>
			</el-col>
		</el-row>
		<el-row v-if="SelectIndexs == 1" class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange1"
						@current-change="handleCurrentChange1"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total1"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
					}}
				</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="SalTruInfoView" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[7936]')" queryData="SalTruInfoView" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>

		<el-dialog v-dialogDrag :title="$t('getapi[1273]')" :visible.sync="monthCheckVisible" width="30%">
			<table>
				<tr>
					<td style="width:60px">{{ $t("getapi[1974]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="year"
								size="mini"
								style="margin-righ:20px"
						>
							<el-option
									v-for="item in yearList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
					<td style="width:60px">{{ $t("getapi[1975]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="month"
								size="mini"
								style="margin-righ:20px"
								@change="getMonthData()"
						>
							<el-option
									v-for="item in monthList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
				</tr>
			</table>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="monthCheckVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmMonthCheck(0)">{{$t('getapi[2051]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {Loading} from 'element-ui';
    export default {
        name:'saleinfo',
        data() {
            return {
                tableOption: {
                    border: true,
                    height: Common.tableHeight3 - Common.reduceTableHeight1_1, // 主表高度ss
                    maxHeight: Common.tableHeight3 // 主表高度
                },
                tableOption1:{
                    border: true,
                    height: Common.tableHeight3 - Common.reduceTableHeight2, // 主表高度ss
                    maxHeight: Common.tableHeight3 // 主表高度
                },
                tableHeader: [],
                dataSet: [], // 主表数据
                dataSet1: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('saleinfo'), // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('saleinfo'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                total1: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: Common.tableHeight3, // 主表高度
                reduceTableHeight: Common.reduceTableHeight1,
                monthList: [
                    {
                        value: 1,
                        label: 1,
                    },
                    {
                        value: 2,
                        label: 2,
                    },
                    {
                        value: 3,
                        label: 3,
                    },
                    {
                        value: 4,
                        label: 4,
                    },
                    {
                        value: 5,
                        label: 5,
                    },
                    {
                        value: 6,
                        label: 6,
                    },
                    {
                        value: 7,
                        label: 7,
                    },
                    {
                        value: 8,
                        label: 8,
                    },
                    {
                        value: 9,
                        label: 9,
                    },
                    {
                        value: 10,
                        label: 10,
                    },
                    {
                        value: 11,
                        label: 11,
                    },
                    {
                        value: 12,
                        label: 12,
                    },
                ],
                yearList: [],
				month:'',
				yearL:'',
				btn:{
                    monthcheck: true
				},
                selectData1:[],
                monthCheckVisible: false,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            let thisyear = new Date().getFullYear();
            for (let i = 0; i < 5; i++) {
                let obj = {
                    value: thisyear - i,
                    label: thisyear - i,
                };
                that.yearList.push(obj);
            }
            that.year = thisyear;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SalTruInfoView', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[7936]"),this.$t("getapi[14]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
                if (that.$limits.authority('plv4', 549, 1) == 1) {
                    that.btn.monthcheck = true;
                } else {
                    that.btn.monthcheck = false;
				}
				if(that.SelectIndexs == 1 && that.selectData1.length > 0){
                    that.$refs.SetBtn.SetOneBtnEnable('del', true);
				} else {
                    that.$refs.SetBtn.SetOneBtnEnable('del', false)
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('saleinfo',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalTruInfoView');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            tabclick(tab){
                let that = this;
                console.log(tab.name)
                that.SelectIndexs = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
                that.colsort();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                if(that.SelectIndex == 1){
                    data.PageIndex = that.pageIndex1
                    data.PageSize = that.pageSize1
                }
                if(that.SelectIndexs == 0){
                    that.$http.urlpost('/Sal/Tru/SaleInfoTab', data, function(res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                            that.DbTbNames = res.DbTbNames;
                            that.authority();
                        }
                        that.loading = false;
                    });
                } else if(that.SelectIndexs == 1){
                    that.$http.urlpost('/Sal/Tru/Sal_TruInfoViewList', data, function(res) {
                        if (res.Success == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                            that.DbTbNames = res.DbTbNames;
                            that.authority();
                        }
                        that.loading = false;
                    });
                }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('/Sal/Tru/SaleInfoTabExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SalTruInfoView",
                    fromname: that.$t('getapi[7936]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            monthCheck(val) {
                let that = this
				that.monthCheckVisible = true
            },
			confirmMonthCheck(val){
                let that = this
                if (that.month == '' || that.year == '') {
                    that.$message.warning(that.$t('getapi[8783]'))//'年月不能为空'
                    return
                }
                let parm = {
                    TYear: that.year,
                    Month: that.month,
                    Confirmflag: val
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Sal/Tru/SaleInfoMonthCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.monthCheckVisible = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmMonthCheck(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    loadingInstance.close()
                });
			},
            impt(){
                let item = {
                    label: this.$t("getapi[9904]"),
                    name: 'saltruinfoimp',
                    path: '/saltruinfoimp',
                    url: '/saltruinfoimp',
                    icon: 'video-play'
                };
                this.$router.push({path: '/saltruinfoimp'});
                this.$store.commit('selectMenu', item);
            },
            handleSelectionChange1(val) {
                let that = this;
                that.selectData1 = val
                that.authority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(that.SelectIndexs == 1){
                            let parm = that.selectData1
                            that.$refs.SetBtn.SetOneBtnEnable('del', false);
                            that.$http.urlpost('/Sal/Tru/DeleteSal_TruInfoViewTransaction', parm, function (res) {
                                that.$refs.SetBtn.SetOneBtnEnable('del', true);
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getView();
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });

            },
        }
    };
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
